import Service from '../../Services/Service';

const BranchAPI = {
    getBranchAll(lang){
        return Service.get('/branch/get_branch_language?language='+lang);
    },
    getBranchById(id){
        return Service.get('/branch/branches/'+id);
    },
    getMiniByBranch(id, lang){
        return Service.get(`/branch/get_mini_by_branch?branch_id=${id}&lang=${lang}`);
    },
    getSiteLeftMenu(){
        return Service.get(`/site/left-menu`);
    }
}
export default BranchAPI
